import { Colors, Text } from '@amelio/ui-library';

export interface TipStackedItem {
    title: string;
    description: string;
}

interface TipStackedContentProps {
    items: TipStackedItem[];
}

export const TipStackedContent = ({ items }: TipStackedContentProps) => {
    return (
        <div className={'space-y-3 rounded-lg border border-slate-200 bg-white !p-4 !p-6 md:!p-6'}>
            {items.map((item) => (
                <div
                    key={item.title}
                    className={'space-y-1'}
                >
                    <Text
                        size={'default'}
                        weight={'semibold'}
                        color={Colors.BASE_600}
                        className={'!text-[#282b48]'}
                    >
                        {item.title}
                    </Text>

                    <Text
                        size={'small'}
                        color={Colors.BASE_400}
                        className={'!text-[#64748b]'}
                    >
                        {item.description}
                    </Text>
                </div>
            ))}
        </div>
    );
};

export default TipStackedContent;
